// extracted by mini-css-extract-plugin
export default {"brandPromo":"hH-z","carousel":"iH-z"};